import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import AgreementsPage from "./pages/AgreementsPage";
import DocumentsPage from "./pages/DocumentsPage";
import HomePage from "./pages/HomePage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import ShippingPolicyPage from "./pages/ShippingPolicyPage";
import IntellectualPropertyPolicyPage from "./pages/IntellectualPropertyPolicyPage";
import CodeOfConductPage from "./pages/CodeOfConductPage";
import DisputeResolutionPolicyPage from "./pages/DisputeResolutionPolicyPage";
import DataProcessingAgreementPage from "./pages/DataProcessingAgreementPage";
import ServiceLevelAgreementPage from "./pages/ServiceLevelAgreementPage";
import AccountSuspensionPolicyPage from "./pages/AccountSuspensionPolicyPage";
import BuyerProtectionPolicyPage from "./pages/BuyerProtectionPolicyPage";
import CancellationPolicyPage from "./pages/CancellationPolicyPage";
import CommissionFeeStructurePage from "./pages/CommissionFeeStructurePage";
import ContentReviewPolicyPage from "./pages/ContentReviewPolicyPage";
import LegalCompliancePolicyPage from "./pages/LegalCompliancePolicyPage";
import PaymentPolicyPage from "./pages/PaymentPolicyPage";
import ProhibitedItemsPolicyPage from "./pages/ProhibitedItemsPolicyPage";
import SellerPolicyPage from "./pages/SellerPolicyPage";
import DeleteAccountPolicyPage from "./pages/DeleteAccountPolicyPage";

function App() {
  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/documents" element={<DocumentsPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route
              path="/account-suspension-policy"
              element={<AccountSuspensionPolicyPage />}
            />
            <Route
              path="/buyer-protection-policy"
              element={<BuyerProtectionPolicyPage />}
            />
            <Route
              path="/cancellation-policy"
              element={<CancellationPolicyPage />}
            />
            <Route
              path="/commission-fee-structure"
              element={<CommissionFeeStructurePage />}
            />
            <Route
              path="/content-review-policy"
              element={<ContentReviewPolicyPage />}
            />
            <Route
              path="/dispute-resolution-policy"
              element={<DisputeResolutionPolicyPage />}
            />
            <Route
              path="/intellectual-property-policy"
              element={<IntellectualPropertyPolicyPage />}
            />
            <Route
              path="/legal-compliance-policy"
              element={<LegalCompliancePolicyPage />}
            />
            <Route path="/payment-policy" element={<PaymentPolicyPage />} />
            <Route
              path="/prohibited-items-policy"
              element={<ProhibitedItemsPolicyPage />}
            />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
            <Route path="/seller-policy" element={<SellerPolicyPage />} />
            <Route path="/shipping-policy" element={<ShippingPolicyPage />} />
            <Route path="/agreements" element={<AgreementsPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="/code-of-conduct" element={<CodeOfConductPage />} />
            <Route
              path="/data-processing-agreement"
              element={<DataProcessingAgreementPage />}
            />
            <Route
              path="/service-level-agreement"
              element={<ServiceLevelAgreementPage />}
            />
            <Route
              path="/delete-account"
              element={<DeleteAccountPolicyPage />}
            />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;
